module.exports = __webpack_public_path__ + "img/IMG_7814.376271d6.jpeg";